export default {
  LIST(state, data) {
    state.requestLetters = data
  },
  GET(state, data) {
    state.requestLetter = data
  },
  UPDATE(state, data) {
    state.requestLetter = { ...data }
  },
  FRESH(state) {
    state.requestLetter = {
      id: null,
      title: '',
      body: '',
      apply_docs: [],
      attachment_file: null,
    }
  },
}
